import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useThemeMode} from '../../../_metronic/partials'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const BODY_CLASSES = ['bgi-size-cover', 'bgi-position-center', 'bgi-no-repeat']
const InfoLayout = () => {
  const {mode} = useThemeMode()
  useEffect(() => {
    BODY_CLASSES.forEach((c) => document.body.classList.add(c))
    document.body.style.backgroundImage =
      mode === 'dark'
        ? `url(${toAbsoluteUrl('/media/auth/bg7-dark.jpg')})`
        : `url(${toAbsoluteUrl('/media/auth/bg7.jpg')})`

    return () => {
      BODY_CLASSES.forEach((c) => document.body.classList.remove(c))
      document.body.style.backgroundImage = 'none'
    }
  }, [mode])

  return (
    <div className='d-flex flex-column flex-root'>
  <div className='d-flex flex-column flex-center flex-column-fluid'>
    <div className='d-flex flex-column flex-center text-center p-2'>
      <div className='card card-flush w-lg-650px'>
        <div className='card-header  d-flex justify-content-center align-items-center'>
          <div className='card-title'>
            <img
              // src="/beta/media/logos/LivetecsLogo.svg"
              src="/media/logos/LivetecsLogo.svg"
              className="h-35px app-sidebar-logo-default theme-light-show"
              alt="Logo"
            />
          </div>
        </div>
        <div className='card-body py-1 py-lg-5'>
          <Outlet />
        </div>
      </div>
    </div>
  </div>
</div>

    // <div className='d-flex flex-column flex-root'>
    //   <div className='d-flex flex-column flex-center flex-column-fluid'>
    //     <div className='d-flex flex-column flex-center text-center p-2'>
    //       <div className='card card-flush  w-lg-650px '>
    //       <div className='card-header pt-5'>
    //           <div className='card-title d-flex flex-column '>
    //             <div className='card-title d-flex flex-column'>
    //               <img
    //                 src="/beta//media/logos/LivetecsLogo.svg"
    //                 className="h-35px app-sidebar-logo-default theme-light-show "
    //                 alt="Logo"
    //               />
    //             </div>
    //           </div>
    //         </div>
    //         <div className='card-body py-1 py-lg-10'>
    //           <Outlet />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  )
}

export {InfoLayout}
